import clsx from 'clsx';
import jsCookie from 'js-cookie';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';

import { Button } from '@/shared/components/atoms';
import { ILanguageItemSelector } from '@/shared/components/atoms/LanguageSelector/LanguageSelector';
import { LangList } from '@/shared/components/atoms/LanguageSelector/languagesList';
import { cookieExpires } from '@/shared/constant/general';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

const LanguageItemSelector: React.FC<ILanguageItemSelector> = ({
  handleSelectLanguage,
  language,
  selected,
}) => {
  const isSelected: boolean = selected === language;
  const containerClassNames = clsx(
    'flex items-center gap-2 py-2 cursor-pointer w-full max-w-[200px] rounded-xl py-1 px-2',
    isSelected
      ? 'border-xs border-primary-default bg-outline-default font-bold'
      : 'bg-background-transparent'
  );

  return (
    <div
      onClick={() => handleSelectLanguage(language)}
      className={containerClassNames}
    >
      <div className='flex h-24 w-24 items-center justify-center overflow-hidden rounded-lg text-40'>
        <span>{LangList[language].flag}</span>
      </div>
      <div>{LangList[language].name}</div>
    </div>
  );
};

const ChangeLanguageModal = () => {
  const { asPath, push, locale } = useRouter();
  const [selectedLang, setSelectedLang] = useState<string | undefined>(locale);
  const { t, i18n } = useTranslation('common');
  const { closeModal } = useModal();

  const handleChangeLanguage = (lang: string) => {
    setSelectedLang(lang);
  };
  const handleChangeConfirmation = () => {
    if (selectedLang) {
      jsCookie.set('lang', selectedLang, {
        path: '/',
        sameSite: 'Strict',
        expires: cookieExpires,
      });

      // Change the locale in the URL and i18n
      i18n.changeLanguage(selectedLang);
      push(asPath, undefined, { locale: selectedLang }).then(() =>
        window.location.reload()
      );
    }
  };

  return (
    <div className='flex w-full flex-col tablet:min-w-[414px]'>
      <div className='mb-16 flex flex-col'>
        {Object.entries(LangList).map(([key]) => {
          return (
            <LanguageItemSelector
              key={key}
              handleSelectLanguage={handleChangeLanguage}
              language={key}
              selected={selectedLang}
            />
          );
        })}
      </div>
      <div className='flex w-full flex-col gap-2'>
        <Button
          color='primary'
          className='py-2'
          size='full'
          onClick={() => closeModal()}
          variant='text'
        >
          {t('back')}
        </Button>
        <Button
          color='primary'
          className='py-2'
          size='full'
          onClick={handleChangeConfirmation}
        >
          {t('change-language')}
        </Button>
      </div>
    </div>
  );
};
export default ChangeLanguageModal;
